import $ from 'jquery'
import 'jquery-ui-dist/jquery-ui'
window.jquery = window.$ = $



export default function init_Filters(){


    $( document ).ready(function($){
    
        // these control the new activity finder details page filters select lsits
        if (document.getElementById('toddetails')) {
    
            $('#start').change(function(e){
                document.getElementById('start').style.color = "#191818";
            });
            
            $('#filter-clear-detail').click(function(e){  
                $('#af-detail')[0].reset();              
                document.getElementById('start').style.color = "#A3A3A3";
                document.getElementById('start').value = "Start Date";
                document.getElementById('factitle').style.color = "#A3A3A3";
                document.getElementById('factitle').innerHTML = "Location";
                document.getElementById('todtitle').style.color = "#A3A3A3";
                document.getElementById('todtitle').innerHTML = "Time of Day";
                if (document.getElementById('agetitle')) {
                    document.getElementById('agetitle').style.color = "#A3A3A3";
                    document.getElementById('agetitle').innerHTML = "Age";
                }
                if (document.getElementById('lengthtitle')) {
                    document.getElementById('lengthtitle').style.color = "#A3A3A3";
                    document.getElementById('lengthtitle').innerHTML = "Length";
                }
                document.getElementById('dowtitle').style.color = "#A3A3A3";
            });

            

            document.getElementById('toddetails').style.display = "none";
            $('#tod-div').click(function(e){
                if (document.getElementById('toddetails').style.display === "none") {
                    document.getElementById('toddetails').style.display = "flex";
                    document.getElementById('tod-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('toddetails').style.display = "none";
                    document.getElementById('tod-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            $('#season-div').click(function(e){
                if (document.getElementById('seasondetails').style.display === "none") {
                    document.getElementById('seasondetails').style.display = "flex";
                    document.getElementById('season-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('seasondetails').style.display = "none";
                    document.getElementById('season-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            if (document.getElementById('agedetails')) {
                document.getElementById('agedetails').style.display = "none";
                $('#age-div').click(function(e){
                    if (document.getElementById('agedetails').style.display === "none") {
                        document.getElementById('agedetails').style.display = "flex";
                        document.getElementById('age-div').style.border = "1px solid rgba(0,79,255)";
                        $(this).addClass('active');
                    } else {
                        document.getElementById('agedetails').style.display = "none";
                        document.getElementById('age-div').style.border = "none";
                        $(this).removeClass('active');
                    }
                });
            }
            if (document.getElementById('lengthdetails')) {
                document.getElementById('lengthdetails').style.display = "none";
                $('#length-div').click(function(e){
                    if (document.getElementById('lengthdetails').style.display === "none") {
                        document.getElementById('lengthdetails').style.display = "flex";
                        document.getElementById('length-div').style.border = "1px solid rgba(0,79,255)";
                        $(this).addClass('active');
                    } else {
                        document.getElementById('lengthdetails').style.display = "none";
                        document.getElementById('length-div').style.border = "none";
                        $(this).removeClass('active');
                    }
                });
            }
            document.getElementById('facdetails').style.display = "none";
            $('#facility-div').click(function(e){
                if (document.getElementById('facdetails').style.display === "none") {
                    document.getElementById('facdetails').style.display = "flex";
                    document.getElementById('facility-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('facdetails').style.display = "none";
                    document.getElementById('facility-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });  
        }    
    
        // these control the new activity finder main page filters select lsits
        if (document.getElementById('activity-details')) {
        
            if (document.getElementById('activity-title').innerHTML !== 'Activity') {
                document.getElementById('activity-title').style.color = "#191818";
            }
            if (document.getElementById('activitytype-title').innerHTML !== 'Activity Type') {
                document.getElementById('activitytype-title').style.color = "#191818";
            }
            if (document.getElementById('ageRange-title').innerHTML !== 'Age Group') {
                document.getElementById('ageRange-title').style.color = "#191818";
            }
            if (document.getElementById('skillLevel-title').innerHTML !== 'Skill Level') {
                document.getElementById('skillLevel-title').style.color = "#191818";
            }
            if (document.getElementById('gender-title').innerHTML !== 'Gender') {
                document.getElementById('gender-title').style.color = "#191818";
            }
            if (document.getElementById('location-title').innerHTML !== 'Location') {
                document.getElementById('location-title').style.color = "#191818";
            }

            document.getElementById('activity-details').style.display = "none";
            $(document).on('click','#activity-div',function(e){
                if (document.getElementById('activity-details').style.display === "none" && $(this).hasClass( "disable" ) === false) {
                    document.getElementById('activity-details').style.display = "flex";
                    document.getElementById('activity-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('activity-details').style.display = "none";
                    document.getElementById('activity-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            document.getElementById('activitytype-details').style.display = "none";
            $('#activitytype-div').click(function(e){
                if (document.getElementById('activitytype-details').style.display === "none" && $(this).hasClass( "disable" ) === false) {
                    document.getElementById('activitytype-details').style.display = "flex";
                    document.getElementById('activitytype-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('activitytype-details').style.display = "none";
                    document.getElementById('activitytype-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            document.getElementById('ageRange-details').style.display = "none";
            $('#ageRange-div').click(function(e){
                if (document.getElementById('ageRange-details').style.display === "none" && $(this).hasClass( "disable" ) === false) {
                    document.getElementById('ageRange-details').style.display = "flex";
                    document.getElementById('ageRange-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('ageRange-details').style.display = "none";
                    document.getElementById('ageRange-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            document.getElementById('skillLevel-details').style.display = "none";
            $('#skillLevel-div').click(function(e){
                if (document.getElementById('skillLevel-details').style.display === "none" && $(this).hasClass( "disable" ) === false) {
                    document.getElementById('skillLevel-details').style.display = "flex";
                    document.getElementById('skillLevel-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('skillLevel-details').style.display = "none";
                    document.getElementById('skillLevel-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            document.getElementById('gender-details').style.display = "none";
            $('#gender-div').click(function(e){
                if (document.getElementById('gender-details').style.display === "none" && $(this).hasClass( "disable" ) === false) {
                    document.getElementById('gender-details').style.display = "flex";
                    document.getElementById('gender-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('gender-details').style.display = "none";
                    document.getElementById('gender-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            document.getElementById('location-details').style.display = "none";
            $('#location-div').click(function(e){
                if (document.getElementById('location-details').style.display === "none" && $(this).hasClass( "disable" ) === false) {
                    document.getElementById('location-details').style.display = "flex";
                    document.getElementById('location-div').style.border = "1px solid rgba(0,79,255)";
                    $(this).addClass('active');
                } else {
                    document.getElementById('location-details').style.display = "none";
                    document.getElementById('location-div').style.border = "none";
                    $(this).removeClass('active');
                }
            });
            $('#filter-clear,#filter-clear-m').click(function(e){
                window.location.href = window.location.origin+"/activities/";
            });
            $('#filter-clear-detail').click(function(e){                
                document.getElementById('factitle').innerHTML = "Location";
                document.getElementById('starttitle').innerHTML = "Start Date";
                document.getElementById('toddetails').innerHTML = "Time of Day";
                document.getElementById('agedetails').innerHTML = "Age";
            });
            $('#showmore-div,#showmore-div-m').click(function(e){
                if (document.getElementById('showmore').innerHTML === "Show More") {
                    document.getElementById('showmore').innerHTML = "Show Less";
                    document.getElementById('showmore-m').innerHTML = "Show Less";
                    $('#showmore-div').addClass('less');
                    $('#showmore-div-m').addClass('less');
                    $('#btndesktop').addClass('less');
                    $('#btnmobile').addClass('less');
                    $('#result-cards').addClass('less');
                    document.getElementById('containerwrapper').style.display = "flex";
                } else {
                    document.getElementById('showmore').innerHTML = "Show More";
                    document.getElementById('showmore-m').innerHTML = "Show More";
                    $('#showmore-div').removeClass('less');
                    $('#showmore-div-m').addClass('less');
                    $('#btndesktop').removeClass('less');
                    $('#btnmobile').removeClass('less');
                    $('#result-cards').removeClass('less');
                    document.getElementById('containerwrapper').style.display = "none";
                }
            });
        }
        $( "#start" ).datepicker({
            onSelect: function(date){
                $('#starttitle').trigger('click');
            }
        });
    });

    $(document).click(function(e){
        if (document.getElementById('activity-details')) {
            if (e.target.id !== 'activity-div' && e.target.id !='activity-title'
            && e.target.id !== 'activitytype-div' && e.target.id !='activitytype-title'
            && e.target.id !== 'ageRange-div' && e.target.id !='ageRange-title'
            && e.target.id !== 'skillLevel-div' && e.target.id !='skilllevel-title'
            && e.target.id !== 'gender-div' && e.target.id !='gender-title'
            && e.target.id !== 'location-div' && e.target.id !='location-title'){
                $('#activity-div').removeClass('active');
                $('#activitytype-div').removeClass('active');
                $('#ageRange-div').removeClass('active');
                $('#skillLevel-div').removeClass('active');
                $('#gender-div').removeClass('active');
                $('#location-div').removeClass('active');
            }
        }
        if (document.getElementById('toddetails')) {
            if (e.target.id !== 'facility-div' && e.target.id !='factitle'
            && e.target.id !== 'tod-div' && e.target.id !='todtitle'
            && e.target.id !== 'agediv' && e.target.id !='agetitle'
            && e.target.id !== 'lengthdiv' && e.target.id !='lengthtitle') {
                $('#facility-div').removeClass('active');
                $('#tod-div').removeClass('active');
                $('#age-div').removeClass('active');
                $('#length-div').removeClass('active');
            }
        }
        if (document.getElementById('toddetails') && e.target.id !== 'toddetails' && e.target.id !== 'tod-div' && e.target.id !== 'todtitle') {
           document.getElementById('toddetails').style.display = "none";
           document.getElementById('tod-div').style.border = "none";
        }
        if (document.getElementById('agedetails') && e.target.id !== 'agedetails' && e.target.id !== 'age-div' && e.target.id !== 'agetitle') {
            document.getElementById('agedetails').style.display = "none";
            document.getElementById('age-div').style.border = "none";
        }
        if (document.getElementById('lengthdetails') && e.target.id !== 'lengthdetails' && e.target.id !== 'length-div' && e.target.id !== 'lengthtitle') {
            document.getElementById('lengthdetails').style.display = "none";
            document.getElementById('length-div').style.border = "none";
        }
        if (document.getElementById('facdetails') && e.target.id !== 'facdetails' && e.target.id !== 'facility-div' && e.target.id !== 'factitle') {
           document.getElementById('facdetails').style.display = "none";
           document.getElementById('facility-div').style.border = "none";
        }
        if (document.getElementById('activity-details') && e.target.id !== 'activity-details' && e.target.id !== 'activity-div' && e.target.id !== 'activity-title') {
           document.getElementById('activity-details').style.display = "none";
           document.getElementById('activity-div').style.border = "none";
        }
        if (document.getElementById('activitytype-details') && e.target.id !== 'activitytype-details' && e.target.id !== 'activitytype-div' && e.target.id !== 'activitytype-title') {
           document.getElementById('activitytype-details').style.display = "none";
           document.getElementById('activitytype-div').style.border = "none";
        }
        if (document.getElementById('ageRange-details') && e.target.id !== 'ageRange-details' && e.target.id !== 'ageRange-div' && e.target.id !== 'ageRange-title') {
           document.getElementById('ageRange-details').style.display = "none";
           document.getElementById('ageRange-div').style.border = "none";
        }
        if (document.getElementById('skillLevel-details') && e.target.id !== 'skillLevel-details' && e.target.id !== 'skillLevel-div' && e.target.id !== 'skillLevel-title') {
           document.getElementById('skillLevel-details').style.display = "none";
           document.getElementById('skillLevel-div').style.border = "none";
        }
        if (document.getElementById('gender-details') && e.target.id !== 'gender-details' && e.target.id !== 'gender-div' && e.target.id !== 'gender-title') {
           document.getElementById('gender-details').style.display = "none";
           document.getElementById('gender-div').style.border = "none";
        }
        if (document.getElementById('location-details') && e.target.id !== 'location-details' && e.target.id !== 'location-div' && e.target.id !== 'location-title') {
           document.getElementById('location-details').style.display = "none";
           document.getElementById('location-div').style.border = "none";
        }
    });
}